import { PrivateRoute } from 'components/route'
import { Switch, useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions.generated'
import { AutorizacaoAbsorventesListaAtendimentoModal } from 'view/dignidade-menstrual/AutorizacaoAbsorventesListaAtendimentoModal'

import { AtendimentoDoDiaView } from './list/actions/atendimento-do-dia/AtendimentoDiaModal'
import { ChamarCidadaoView } from './list/actions/chamar/ChamarCidadaoView'
import { GerarDeclaracaoComparecimentoView } from './list/actions/declaracao-comparecimento/GerarDeclaracaoComparecimentoView'
import { EditarAtendimentoModalForm } from './list/actions/editar/EditarAtendimentoModalForm'
import { ListaAtendimentosView } from './list/ListaAtendimentoView'

export function ListaAtendimentoRootView() {
  const match = useRouteMatch()

  return (
    <>
      <ListaAtendimentosView />
      <Switch>
        <PrivateRoute
          path={`${match.url}/declaracaoComparecimento/:atendId(\\d+)`}
          component={GerarDeclaracaoComparecimentoView}
          permission={Permissions.visualizarListaDeAtendimento.gerarDeclaracaoDeComparecimento}
        />

        <PrivateRoute
          path={`${match.url}/painel-chamada/:atendimentoId(\\d+)`}
          component={ChamarCidadaoView}
          permission={Permissions.visualizarListaDeAtendimento.chamarCidadaoNoPainelDeChamadas}
        />

        <PrivateRoute
          path={`${match.url}/atendimentoDoDia/:atendimentoId(\\d+)`}
          component={AtendimentoDoDiaView}
          permission={Permissions.visualizarListaDeAtendimento}
        />

        <PrivateRoute
          path={`${match.url}/editar/:atendimentoId(\\d+)`}
          component={EditarAtendimentoModalForm}
          permission={Permissions.visualizarListaDeAtendimento.cadastrarEditarEExcluir}
        />

        <PrivateRoute
          path={`${match.url}/cidadao/:cidadaoId(\\d+)/autorizacao-absorventes`}
          component={AutorizacaoAbsorventesListaAtendimentoModal}
          permission={Permissions.visualizarListaDeAtendimento.gerarAutorizacaoParaRetiradaDeAbsorventes}
        />
      </Switch>
    </>
  )
}
